import { Component, OnInit, OnDestroy, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ng2-bootstrap';
import { EntityrecordApi, EntityApi } from '../../../sdk/services/custom';
import { LoopBackFilter, Entity, Entityfield, Entityrecord } from '../../../sdk/models';
import { LoopBackAuth } from '../../../sdk/services/core/auth.service';
import { PlatformApp } from '../../../services/app.service';
import { Observable } from 'rxjs/Rx';
import { FormBuilder, FormGroup } from "@angular/forms";
import { FormlyFieldConfig, } from 'ng-formly';
import * as _ from "lodash";
import { PushNotificationsService, NotificationsService } from 'angular2-notifications';

@Component({
    selector: 'notes-textbox',
    templateUrl: './notes-textbox.component.html',
    providers: [EntityrecordApi, EntityApi],
    styleUrls: ['./notes-textbox.component.scss']

})

export class NotesTextBoxComponent implements OnInit, OnDestroy {
    @Input() entityid: string;
    @Input() entityrecordid: string;
    @Input() title = '';
    @Output() onChanged: EventEmitter<Entityrecord> = new EventEmitter(true);
    buttontext = "New ";
    dataelement: any;
    subscriptions: any = [];
    filter: LoopBackFilter = <LoopBackFilter>{};
    currentuser: any;
    entityResponse = {};
    entity: Entity = new Entity();
    entityRecord: Entityrecord = new Entityrecord();
    fullEntityRecord: Entityrecord = new Entityrecord();
    entityDataFields: Array<Entityfield> = [];
    entityFormFields: Array<FormlyFieldConfig> = [];
    entityrecordtitle = '';
    entityRecordState = '';
    initialFormData: any;
    formOptions: any = {};
    form: FormGroup;
    formEntityFields: any = [];
    formEntityRecord: Entityrecord = new Entityrecord();
    @ViewChild('editModal') public editModal: ModalDirective;
    notifyOptions = PlatformApp.getNotificationOptions();

    constructor(private _EntityrecordApi: EntityrecordApi, private _EntityApi: EntityApi,
        private _NotificationsService: NotificationsService, private _PushNotificationsService: PushNotificationsService,
        private _LoopBackAuth: LoopBackAuth, private fb: FormBuilder) {

    }

    ngOnInit(): void {
        this.currentuser = this._LoopBackAuth.getCurrentUserData();
        this.getEntityRecord();
        this.form = this.fb.group({});
        if (this.entityrecordid) {
            this.buttontext = "Edit ";
        }
    }

    getEntityRecord(): void {
        this.subscriptions.push(Observable.forkJoin(
            this._EntityrecordApi.findByIdProcessed(this.entityrecordid).map((res: Entityrecord) => res),
            this._EntityApi.getEntityDetails(this.entityid).map((res: any) => res))
            .subscribe((data) => {
                this.entityRecordState = null;
                this.entityRecord = _.cloneDeep(data[0]["response"]);
                this.entityResponse = _.cloneDeep(data[1]);
                this.entityRecord.appId = this.currentuser.appId;
                this.entity = this.entityResponse['entity'];
                this.entityDataFields = this.entityResponse['datafields'];
                this.entityFormFields = this.entityResponse['formfields'];
                this.entityrecordtitle = this.entityRecord.data[this.entity.record_name];
                this.buttontext = this.buttontext + this.entity.label;
            },
                err => this.entityRecordState = err.message
            ));
        this.entityResponse = {};
    }

    showNewModal() {}
    
    public showEditModal(entityRecord): void {
        this.formEntityRecord = new Entityrecord();
        this.subscriptions.push(this._EntityrecordApi.findByIdforEdit(entityRecord.id)
            .subscribe((record) => {
                if (record && record['response']) {
                    if (record['response']['record'] && record['response']['record']['data']) {
                        this.formEntityRecord = _.cloneDeep(record['response']['record']['data']);
                    }
                    if (record['response']['formfields']) {
                        this.entityFormFields = record['response']['formfields'];
                    }
                    this.formEntityFields = _.cloneDeep(this.entityFormFields);

                    this.formEntityRecord.id = entityRecord.id;
                    this.editModal.show();
                } else {
                    console.log('ERROR - Loading Record ' + entityRecord.id);
                    this.notify('error', 'Record', 'Not Loaded; Please refresh');
                }
            }));
    }

    public hideEditModal(): void {
        if (this.form && this.form['subscriptions'])
            this.form['subscriptions'].forEach(s => { s.unsubscribe(); });
        if (this.form)
            this.form = this.fb.group({});
        this.editModal.hide();
    }

    resetFormData(): void {
        if (this.initialFormData) {
            this.formOptions.resetModel(this.initialFormData);
            this.form.reset(this.initialFormData);
        } else {
            this.formOptions.resetModel({});
            this.form.reset();
        }
    }

    ngOnDestroy() {
        for (var i = 0; i < this.subscriptions.length; i++) this.subscriptions[i].unsubscribe();
    }

    patchOrCreateEntity(formEntityRecord): void {
        var entityRecordforSave = new Entityrecord();
        entityRecordforSave.data = formEntityRecord;
        entityRecordforSave.lastupdatedby = this.currentuser.id;

        //Hack to remove the appId;
        delete entityRecordforSave.data.appId;

        //Hack to update Date and Time in UI TimeZone.
        for (var i = 0; i < this.entityDataFields.length; i++) {
            if (this.entityDataFields[i].fieldtype === 'date' || this.entityDataFields[i].fieldtype === 'datetime') {
                var dateStr = PlatformApp.stringToDate(entityRecordforSave.data[this.entityDataFields[i].name], null, null).toISOString();
                if (dateStr)
                    entityRecordforSave.data[this.entityDataFields[i].name] = dateStr;
            }
        }

        if (!formEntityRecord.id) {
            entityRecordforSave.entityId = this.entity.id;
            entityRecordforSave.createdby = this.currentuser.id;
            entityRecordforSave.appId = this.currentuser.appId;

            this.subscriptions.push(this._EntityrecordApi.patchOrCreate(entityRecordforSave)
                .subscribe((newrecord) => {
                    this.entityRecord = newrecord;
                    this.hideEditModal();
                    this.setRecord(newrecord);
                }));
        } else {

            this.subscriptions.push(this._EntityrecordApi.patchAttributes(formEntityRecord.id, entityRecordforSave)
                .subscribe((updatedrecord) => {
                    this.entityRecord = updatedrecord;
                    this.hideEditModal();
                    this.setRecord(updatedrecord);
                }));
        }

    }

    setRecord(record: Entityrecord) {
        this.onChanged.emit(record);
    }

    notify(type, title?, content?, options?) {
        if (!options) options = PlatformApp.getNotificationOptions();
        if (!options.id) options.id = type + '-' + title + '_' + content;
        switch (type) {
            case 'success': this._NotificationsService.success(title, content, options); break;
            case 'alert': this._NotificationsService.alert(title, content, options); break;
            case 'error': this._NotificationsService.error(title, content, options); break;
            case 'info': this._NotificationsService.info(title, content, options); break;
            case 'bare': this._NotificationsService.bare(title, content, options); break;
            default: this._NotificationsService.info(title, content, options);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/widgets/notes-textbox/notes-textbox.component.ts